function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#007853;}.cls-2{fill:#00b451;}.cls-3{fill:#00c4b2;}.cls-4{fill:#00acd8;}.cls-5{fill:#76bc21;}.cls-6{fill:#00698f;}.cls-7{fill:#005487;}.cls-8{fill:#006e96;}.cls-9{fill:#0083ad;}.cls-10{fill:#004876;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M219,107.21a5.2,5.2,0,1,0,4.143-9.539L2.654,1.921a5.228,5.228,0,0,0-.943-.3V12.85Z",
  transform: "translate(-1.711 -1.617)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M219,194.328a5.2,5.2,0,0,0,4.143-9.539L2.654,89.039a5.075,5.075,0,0,0-.943-.3V99.967Z",
  transform: "translate(-1.711 -1.617)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-3",
  d: "M219,129.229a5.2,5.2,0,1,0,4.143-9.539L2.654,23.94a5.228,5.228,0,0,0-.943-.3V34.869Z",
  transform: "translate(-1.711 -1.617)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-4",
  d: "M219,151.089a5.2,5.2,0,1,0,4.143-9.539L2.654,45.8a5.147,5.147,0,0,0-.943-.3V56.728Z",
  transform: "translate(-1.711 -1.617)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-5",
  d: "M219,172.774a5.2,5.2,0,1,0,4.143-9.539L2.654,67.485a5.228,5.228,0,0,0-.943-.3V78.414Z",
  transform: "translate(-1.711 -1.617)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-6",
  d: "M2.654,246.836l220.493-95.75a5.2,5.2,0,0,0-4.143-9.54L1.711,235.907V247.14A5.228,5.228,0,0,0,2.654,246.836Z",
  transform: "translate(-1.711 -1.617)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-7",
  d: "M2.654,224.979l220.493-95.75A5.2,5.2,0,0,0,219,119.69L1.711,214.05v11.233A5.151,5.151,0,0,0,2.654,224.979Z",
  transform: "translate(-1.711 -1.617)"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-8",
  d: "M2.666,268.523l220.493-95.75a5.2,5.2,0,0,0-4.143-9.539L1.723,257.6v11.232A5.175,5.175,0,0,0,2.666,268.523Z",
  transform: "translate(-1.711 -1.617)"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-9",
  d: "M2.666,290.08l220.493-95.751a5.2,5.2,0,0,0-4.143-9.539L1.723,279.151v11.232A5.25,5.25,0,0,0,2.666,290.08Z",
  transform: "translate(-1.711 -1.617)"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-10",
  d: "M2.654,202.965l220.493-95.75A5.2,5.2,0,0,0,219,97.676L1.711,192.036v11.232A5.224,5.224,0,0,0,2.654,202.965Z",
  transform: "translate(-1.711 -1.617)"
});

var SvgVeriforceIcon = function SvgVeriforceIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Logo",
    viewBox: "0 0 224.577 288.766",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVeriforceIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Veriforce Icon.d4bdc0ac.svg";
export { ForwardRef as ReactComponent };